import { AuthenticationLevel } from 'auth';
import ensureUserData from 'utils/ensureUserData';
import { requiredLoginLevel } from 'utils/routes/requiredLoginLevel';

export default {
  isRawContent: true,
  onEnterHandlers: [
    ensureUserData,
    requiredLoginLevel(AuthenticationLevel.LOGGED_IN),
  ],
  childRoutes: [
    {
      path: '/payment/success',
      indexRoute: {
        getComponent(location, callback) {
          import(/* webpackChunkName: "payments" */ './components/PaymentFinishedSuccess')
            .then(component => callback(null, component.default));
        },
      },
    },
    {
      path: '/payment/vbv-failure',
      indexRoute: {
        getComponent(location, callback) {
          import(/* webpackChunkName: "payments" */ './components/PaymentFinishedFailure')
            .then(component => callback(null, component.default));
        },
      },
    },
    {
      path: '/payment/failure',
      indexRoute: {
        getComponent(location, callback) {
          import(/* webpackChunkName: "payments" */ './components/PaymentFinishedFailure')
            .then(component => callback(null, component.default));
        },
      },
    },
    {
      path: '/payment/new/iframe',
      indexRoute: {
        getComponent(location, callback) {
          import(/* webpackChunkName: "payments" */ './containers/AddPaymentFormWithContext')
            .then(component => callback(null, component.default));
        },
      },
    },
    {
      path: '/payment/vbv-start/iframe',
      indexRoute: {
        getComponent(location, callback) {
          import(/* webpackChunkName: "payments" */ './containers/StandaloneCardVerification')
            .then(component => callback(null, component.default));
        },
      },
    },
  ],
};
